export const COMPANY_NAME = 'PARTNERSHIPS FOR ADVANCING COMMUNITY HEALTH';
export const COMPANY_SHORT = 'PACH';
export const COMPANY_TAGLINE = 'Partnerships for Advancing Community Health';
export const COMPANY_ADDRESS_FULL = '1458 5TH ST NW, NEW PHILADELPHIA, OH 44663-1224';
export const COMPANY_LOCATION = 'New Philadelphia, Ohio';
export const COMPANY_REGION = 'Tuscarawas County, Ohio';
export const MAP_URL =
  'https://www.google.com/maps/search/?api=1&query=1458%205TH%20ST%20NW%2C%20NEW%20PHILADELPHIA%2C%20OH%2044663-1224';
export const HERO_IMAGE_URL =
  'https://images.unsplash.com/photo-1582719471384-894fbb16e074?auto=format&fit=crop&w=1600&q=80';
export const HERO_IMAGE_CREDIT_URL = 'https://unsplash.com/photos/B7VLrEWGDLs';

export const MISSION_PILLARS = [
  {
    tag: 'Connect',
    title: 'Community Connections',
    body: 'Convene local clinics, schools, and neighborhood groups around shared public-health priorities.',
  },
  {
    tag: 'Educate',
    title: 'Wellness Literacy',
    body: 'Translate practical wellness information for households across Tuscarawas County and the surrounding region.',
  },
  {
    tag: 'Equip',
    title: 'Partner Resources',
    body: 'Provide a public profile so partners and residents can verify our organization and reach us through the listed address.',
  },
  {
    tag: 'Advocate',
    title: 'Civic Voice',
    body: 'Support a coordinated voice for community health needs in New Philadelphia and the broader Ohio service area.',
  },
];

export const FOCUS_AREAS = [
  {
    label: 'Health Partnerships',
    title: 'Coalition-style collaboration',
    body: 'Cross-sector partners working alongside families, providers, and civic groups to advance community wellness.',
  },
  {
    label: 'Local Outreach',
    title: 'Rooted in New Philadelphia',
    body: 'Programs framed for the residents and neighborhoods of Tuscarawas County rather than a generic catchment area.',
  },
  {
    label: 'Public Profile',
    title: 'Source-backed information',
    body: 'A restrained directory page that keeps the supplied address visible while private registry identifiers stay off the public page.',
  },
];

export const PROFILE_FACTS = [
  { label: 'Focus', value: 'Community Health Partnerships' },
  { label: 'Service Area', value: COMPANY_REGION },
  { label: 'Headquarters', value: COMPANY_LOCATION },
];

export const PUBLIC_INFO = [
  { label: 'Organization', value: COMPANY_NAME },
  { label: 'City / State', value: COMPANY_LOCATION },
  { label: 'Address', value: COMPANY_ADDRESS_FULL },
];
